import { Alert } from "@mui/material";
import * as React from "react";
import { useRouteError } from "react-router";

import { ErrorMonitoringService } from "@/shared/services";

import {
  InvalidWorkspaceConfigError,
  WorkspaceNotFoundError,
} from "../loader/exceptions";

/**
 * Top-most error boundary for the visualization workspace.
 *
 * Reference: https://reactrouter.com/en/main/route/error-element
 */
export function ErrorBoundary() {
  const error = useRouteError();

  React.useEffect(() => {
    ErrorMonitoringService.captureError(error);
  }, [error]);

  // TODO Look into consolidating these errors into one render-able component
  if (error instanceof InvalidWorkspaceConfigError) {
    return (
      <Alert
        severity="error"
        sx={{
          fontSize: "1.125rem",
          margin: "1em 0",
        }}
      >
        {error.message}
      </Alert>
    );
  }

  if (error instanceof WorkspaceNotFoundError) {
    return (
      <Alert
        severity="error"
        sx={{
          fontSize: "1.125rem",
          margin: "1em 0",
        }}
      >
        {error.message}
      </Alert>
    );
  }

  return (
    <Alert
      severity="error"
      sx={{
        fontSize: "1.125rem",
        margin: "1em 0",
      }}
    >
      Something went wrong loading the visualization workspace. Please try
      reloading the page.
    </Alert>
  );
}
